const PillarsSchema = (props) => ({
  title: 'AgSUS Pilares',
  fieldsets: [
    {
      id: 'default',
      title: 'Seção',
      fields: ['eyebrow', 'title', 'columns', 'variant'],
    },
    { id: 'items', title: 'Pilares', fields: ['items'] },
  ],
  properties: {
    eyebrow: {
      title: 'Etiqueta',
      description: 'Texto curto em caixa alta, acima do título.',
    },
    title: { title: 'Título da seção' },
    columns: {
      title: 'Colunas',
      choices: [
        ['2', '2'],
        ['3', '3 (padrão)'],
        ['4', '4'],
      ],
      default: '3',
    },
    variant: {
      title: 'Fundo da seção',
      choices: [
        ['default', 'Paper (branco)'],
        ['alt', 'Surface (off-white)'],
      ],
      default: 'default',
    },
    items: {
      title: 'Pilares',
      description: 'Cada pilar tem um número (ex.: "01"), título e descrição.',
      widget: 'object_list',
      schema: {
        title: 'Pilar',
        fieldsets: [
          { id: 'default', title: 'Default', fields: ['num', 'title', 'body'] },
        ],
        properties: {
          num: {
            title: 'Número',
            description: 'Ex.: "01", "I", "A". Se vazio, usa índice (01, 02, …).',
          },
          title: { title: 'Título' },
          body: { title: 'Descrição', widget: 'textarea' },
        },
        required: ['title'],
      },
    },
  },
  required: [],
});

export default PillarsSchema;
